<template>
	<el-dialog :visible.sync="visible" width="400px" :before-close="beforeClose">
		<div slot="title">
			<span class="yx-color-text-primary font-h3-regular yx-pingfang-Medium">温馨提示</span>
		</div>
		<div class="p-8">
			<div class="yx-color-text-secondary font-h4-regular">您使用的浏览器不支持使用插件，可安装以下任一浏览器来使用插件：</div>
			<div class="mt-24">
				<div class="flex-row-align-center flex-just-between mt-12" v-for="item in browserList" :key="item.key">
					<div>
						<i :class="item.icon"></i>
						<span class="ml-10 font-h4-regular yx-color-text-primary yx-pingfang-Medium">{{ item.label }}</span>
					</div>
					<el-button type="primary" @click="handleGoTutorial(item.link)">点击下载</el-button>
				</div>
			</div>
		</div>
		<div slot="footer">
			<div class="pr-4 pb-8">
				<el-button @click="beforeClose">取消</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
export default {
	computed: {
		browserList() {
			let guge, sll, aoyou, edge, isApple;
			guge = {
				key: 'guge',
				icon: 'i-guge-browser',
				label: '谷歌浏览器',
				link: 'https://www.google.cn/chrome/index.html',
			};
			sll = {
				key: 'sll',
				icon: 'i-sll-browser',
				label: '360浏览器',
				link: 'https://browser.360.cn/se/se.html?src=',
			};
			aoyou = {
				key: 'aoyou',
				icon: 'i-aoyou-browser',
				label: '遨游浏览器',
				link: 'https://www.maxthon.com/zh/download',
			};
			edge = {
				key: 'edge',
				icon: 'i-edge-browser',
				label: 'Edge浏览器',
				link: 'https://www.microsoft.com/zh-cn/edge/download?form=MA13FJ',
			};
			isApple = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent); //是否为苹果设备
			return isApple ? [guge] : [guge, sll, aoyou, edge];
		},
	},
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		handleGoTutorial(link) {
			window.open(link, '_blank');
		},
		beforeClose() {
			this.visible = false;
		},
	},
};
</script>
